/**
 * RelocateDialog — Area picker for moving a resident to a different area.
 */

import { useState, useCallback } from 'react';

const RelocateDialog = ({
  currentAreaId, locationData,
  onClose, onRelocate, saving,
}) => {
  const [selectedAreaId, setSelectedAreaId] = useState('');

  const handleSubmit = useCallback(() => {
    if (!selectedAreaId) return;
    onRelocate(selectedAreaId);
  }, [selectedAreaId, onRelocate]);

  const isValid = selectedAreaId && selectedAreaId.toString() !== currentAreaId?.toString();

  return (
    <div className="pp-dialog-backdrop" onClick={onClose}>
      <div className="pp-dialog" onClick={(e) => e.stopPropagation()}>
        <div className="pp-dialog__header">
          <h2 className="pp-dialog__title">Relocate Resident</h2>
          <button className="dp-drawer__close" onClick={onClose}>&#x2715;</button>
        </div>
        <div className="pp-dialog__body">
          <div className="dp-drawer__field">
            <label className="dp-drawer__label">
              Select New Area <span className="dp-drawer__required">*</span>
            </label>
            <select
              className="dp-drawer__select"
              value={selectedAreaId}
              onChange={(e) => setSelectedAreaId(e.target.value)}
            >
              <option value="">Select an area&hellip;</option>
              {(locationData || []).map((area) => (
                <option key={area.area_id} value={area.area_id}>
                  {area.area_name}
                  {area.area_id?.toString() === currentAreaId?.toString() ? ' (current)' : ''}
                </option>
              ))}
            </select>
          </div>
        </div>
        <div className="pp-dialog__footer">
          <button className="dp-btn dp-btn--cancel" onClick={onClose} disabled={saving}>
            Cancel
          </button>
          <button
            className="dp-btn dp-btn--primary"
            onClick={handleSubmit}
            disabled={saving || !isValid}
          >
            {saving ? 'Relocating\u2026' : 'Relocate'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default RelocateDialog;
